import type { PropsWithChildren } from "react";

import InputLabel from "@/ui/core/InputLabel";
import Text from "@/ui/core/Text";
import { VStack } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

interface LabeledInputProps extends ViewWithTestID, PropsWithChildren {
  hasError?: boolean;
  isOptional?: boolean;
  isRequired?: boolean;
  leftText?: string;
  rightText?: string;
  subLabel?: string;
}

const LabeledInput = ({
  children,
  hasError,
  isOptional,
  isRequired,
  leftText,
  rightText,
  subLabel,
  testID,
}: LabeledInputProps) => (
  <VStack gap={8}>
    {leftText && (
      <InputLabel
        isOptional={isOptional}
        isRequired={isRequired}
        secondaryText={rightText}
        tertiaryText={subLabel}
        testID={testID}
        text={leftText}
      />
    )}
    {children}
    {/* TextArea renders its own error inline with its character count */}
    {hasError && isRequired && (
      <Text
        color={ColorToken.NotificationCriticalText}
        testID={joinTestIDs(testID, "error-message")}
        variant="caption"
      >
        This field is required
      </Text>
    )}
  </VStack>
);

export type { LabeledInputProps };
export default LabeledInput;
